/* eslint-disable no-useless-escape */

export function isContainSpecialChar(value: string) {
  const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return format.test(value);
}

export function isContainUpper(value: string) {
  return /[A-Z]/.test(value);
}

export function isContainLower(value: string) {
  return /[a-z]/.test(value);
}

export function isNumber(value: string) {
  return /[0-9]/.test(value);
}

export function isOnlyDigits (value: string){
  return /^[0-9]+$/.test(value);
}

//from today onwards
export function isInTheFuture (value: string|Date){
  return new Date(value) > new Date();
}

export function beforeToday(value: string | Date){
  const date = new Date(value);
      date.setDate(date.getDate() + 1);
  return !isInTheFuture(date);
}

export function isBefore(value1:string|Date, value2:string|Date){
return new Date(value1) > new Date(value2)

}

// Validates a Nigerian mobile number in local (0XXXXXXXXXX) or international
// (+234 / 234) format. Self-contained because the `nigeria-phone-number-validator`
// package ships no runtime code (its published tarball is missing the `lib/` dir).
export function isValidNigerianPhoneNumber(value: string) {
  if (!value) return false;
  // Strip common separators (spaces, dashes, parentheses) before matching.
  const normalized = value.replace(/[\s()-]/g, "");
  // 11-digit local numbers start with 0; international numbers use +234/234.
  // The subscriber portion begins with 7, 8 or 9 followed by 9 more digits.
  return /^(\+?234|0)[789]\d{9}$/.test(normalized);
}
